import { render, staticRenderFns } from "./LayoutVacation.vue?vue&type=template&id=64974f1e&scoped=true"
import script from "./LayoutVacation.vue?vue&type=script&lang=js"
export * from "./LayoutVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64974f1e",
  null
  
)

export default component.exports